import script from "./echart-right-bar.vue?vue&type=script&lang=ts&setup=true"
export * from "./echart-right-bar.vue?vue&type=script&lang=ts&setup=true"

import "./echart-right-bar.vue?vue&type=style&index=0&id=fbebd572&lang=scss"

const __exports__ = script;

export default __exports__